/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { useMemo } from "react";
import { decorateRichText } from "./utils";

const containerCSS = css`
    padding: 0 16px;

    .trpr__primary-layout-itinerary-metadata[data-min-width~="450"] &,
    .trpr__primary-layout-itinerary-items[data-min-width~="450"] & {
        padding: 0 24px;
    }

    .trpr__primary-layout-itinerary-metadata[data-min-width~="650"] &,
    .trpr__primary-layout-itinerary-items[data-min-width~="650"] & {
        padding: 0 36px;
    }
`;
const wrapperCSS = css`
    background: #e8e8ff;
    color: #505050;
    font-size: 13px;
    line-height: 24px;
    border-radius: 8px;
    border: 1px solid #d3d2fc;
    padding: 16px;

    .trpr__primary-layout-itinerary-metadata[data-min-width~="450"] &,
    .trpr__primary-layout-itinerary-items[data-min-width~="450"] & {
        padding: 23px 24px;
        font-size: 15px;
    }
`;
const bodyCSS = css`
    margin-top: 12px;

    a {
        color: #504cf3;
    }

    ul {
        list-style: initial;
        padding: 0 0 0 1em;
    }

    p {
        line-height: inherit;
        font-size: inherit;
        margin: 0;

        & + p {
            margin-top: 1em;
        }
    }
`;
const headerCSS = ({ newDescription }) => css`
    display: flex;
    align-items: center;

    i {
        margin-right: 12px;
        font-size: 20px;
    }

    span {
        font-weight: 600;
    }

    ${!newDescription &&
        `
        justify-content: center;
    `}

    .trpr__primary-layout-itinerary-metadata[data-min-width~="450"] &,
    .trpr__primary-layout-itinerary-items[data-min-width~="450"] & {
        i {
            font-size: 24px;
        }
    }
`;

function ItineraryEndTween(props) {
    const { className, title, description } = props;
    const newDescription = useMemo(() => decorateRichText(description), [description]);

    return (
        <section className={className} css={containerCSS}>
            <div css={wrapperCSS}>
                <header css={headerCSS({ newDescription })}>
                    <i className="trpr__icon-flag"></i>
                    <span>{title}</span>
                </header>
                {newDescription && <div css={bodyCSS} dangerouslySetInnerHTML={{ __html: newDescription }}></div>}
            </div>
        </section>
    );
}

export default ItineraryEndTween;
